import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class SidebarService {
    private readonly sidebarState: BehaviorSubject<boolean>;

    get state() {
        return this.sidebarState.asObservable();
    }

    constructor() {
        this.sidebarState = new BehaviorSubject(false);
    }

    showSidebar() {
        this.sidebarState.next(true);
    }

    hideSidebar() {
        this.sidebarState.next(false);
    }
}
